import Component from '../../../../js/assets/component.js'

class OutOfStockAlert extends Component {
  constructor(selector) {
    //set root element
    super(selector)
  }

  mounted() {
    this.$buttonClose = this.$el.find('.buttonClose').first()
    let self = this
    this.$buttonClose.on('click', function(e){
      self.$el.fadeOut()
    })
  }
}

//export as singleton
const instance = new OutOfStockAlert("#outOfStockAlert")
// Object.seal(instance)
export default instance
